module.exports = __webpack_public_path__ + "img/Avatar-63.e520d786.svg";